import React from 'react';

import Logo from '@app/shell/SiteHeader/shared/components/Logo';
import NavItemsListDesktop from '@app/shell/SiteHeader/shared/components/NavItemsListDesktop';
import { useIsNonInteractiveViewer } from '@app/ui';
import { MessageListModal } from '@app/inbox';

import { useExperiment } from '@app/experiments';
import { EXPERIMENTS } from '@app/config';
import Browse from '@app/shell/SiteHeader/shared/components/NavItemDesktop/Browse';
import News from '@app/shell/SiteHeader/shared/components/NavItemDesktop/News';
import About from '@app/shell/SiteHeader/shared/components/NavItemDesktop/About';
import Help from '@app/shell/SiteHeader/shared/components/NavItemDesktop/Help';
import Sell from '@app/shell/SiteHeader/shared/components/NavItemDesktop/Sell';
import Account from '@app/shell/SiteHeader/shared/components/NavItemDesktop/Account';
import SearchBox from './components/SearchBox';

const ContentTabletAndDesktop = () => {
  const isNonInteractiveViewer = useIsNonInteractiveViewer();
  const isWomensNavVariant =
    useExperiment(EXPERIMENTS.ab_home_add_womens_navigation_web) === 'variant';

  return (
    <React.Fragment>
      <Logo />
      {!isNonInteractiveViewer && <SearchBox data-component="SearchBox" />}
      <NavItemsListDesktop data-component="HeaderNavbar">
        {!isWomensNavVariant && <Browse key="priceGuideMenu" />}
        <News />
        <About key="AboutNavItemContainer" />
        <Help />
        <Sell />
        {!isNonInteractiveViewer && <MessageListModal />}
        <Account key="myAccountNavBar" />
      </NavItemsListDesktop>
    </React.Fragment>
  );
};

export default ContentTabletAndDesktop;
